import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/arrow/solution_back.webp";

function Solutionarrow() {
  return (
    <section
      className="solution_arrow text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto pt_top">
            <h2>Tekrevol's Solution</h2>
            <p>
              Tekrevol got the initial scope and started to lay out the initial
              framework for the platform.
            </p>
            <p>
              Our goal was simple here; we needed to provide the platform with
              all the functionalities that client wanted but in a way that users
              coming to this platform would be able to easily interact with all
              the features.
            </p>
            <p>
              The final platform consisted of multiple layers and aspects that
              made the platform inherently functional and able to serve all the
              purposes required off of it.
            </p>
            <p>
              The platform had a sign up feature, an internal sales and purchase
              area, a live market rate option on the homepage and an internal
              user lab intended to update current rates and update inventory
              lists.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutionarrow;
